import createSvgIcon from "./utils/create_icon"

const ArrowDownLarge = createSvgIcon(<path d="M5.293 14.293a1 1 0 0 1 1.414 0L11 18.586V3a1 1 0 1 1 2 0v15.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414z" clipRule="evenodd" fill="currentColor" fillRule="evenodd" />, "ArrowDownLarge")
export default ArrowDownLarge
